import { authenticatedApiFetch } from '../utils/utils'

export const getCommunityProfileService = async () => {
    const res = await authenticatedApiFetch('/community-profile/', { method: 'GET' })
        .then(res => res.json())
        .catch((error) => {
            console.error(error)
        })

    if (Array.isArray(res) && res.length > 0) {
        return res[0]
    }

    return res
} 

export const createCommunityProfileService = async (data) => {
    const res = await authenticatedApiFetch('/community-profile/', { 
        method: 'POST', 
        body: JSON.stringify(data) 
    })
        .then(res => res.json())
        .catch((error) => {
            console.error(error)
            throw error
        })
    return res
}

export const getPublicCommunityProfileByIdService = async (id) => {
    const res = await authenticatedApiFetch(`/community-profiles/${id}/`, { method: 'GET' })
        .catch((error) => {
            console.error(error)
            throw error
        })

    if (!res?.ok) {
        const text = await res.text()
        throw new Error(`HTTP ${res?.status}: ${text}`)
    }

    return res.json()
}

export const getAllCommunityProfilesService = async () => {
    
    const res = await authenticatedApiFetch('/community-profiles/', { method: 'GET' })
        .then(res => {
            return res.json()
        })
        .catch((error) => {
            console.error('🌐 Erreur dans getAllCommunityProfilesService:', error)
            return []
        })
    return Array.isArray(res) ? res : []
}